import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import AuthLayout, { CornerLogo, AUTH } from './AuthLayout';

export default function EmailSentPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = (location.state as { email?: string })?.email || 'your email';
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  const handleResend = async () => {
    if (resending || resent || email === 'your email') return;
    setResending(true);
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setResent(true);
    } catch {
      // silent — best-effort resend
    } finally {
      setResending(false);
    }
  };

  return (
    <AuthLayout>
      <div
        style={{
          width: '100%',
          maxWidth: 480,
          backgroundColor: AUTH.cardBg,
          borderRadius: 16,
          padding: '48px 40px',
          boxShadow: 'var(--auth-card-shadow-box)',
          fontFamily: '"Geist", sans-serif',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* Logo */}
        <div style={{ marginBottom: 32 }}>
          <CornerLogo />
        </div>

        {/* Check icon in pink circle */}
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 14,
            backgroundColor: 'var(--auth-accent-badge-bg)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 20,
          }}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 13l4 4L19 7"
              stroke={AUTH.accent}
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Title + subtitle */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 28,
            gap: 8,
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: 22,
              fontWeight: 700,
              color: AUTH.textPrimary,
              letterSpacing: '-0.03em',
              lineHeight: '28px',
              textAlign: 'center',
            }}
          >
            Check your email
          </h1>

          <div style={{ textAlign: 'center' }}>
            <span
              style={{
                fontSize: 14,
                fontWeight: 400,
                color: AUTH.textSecondary,
                lineHeight: '21px',
              }}
            >
              We sent a reset link to
            </span>
            <br />
            <span
              style={{
                fontSize: 14,
                fontWeight: 500,
                color: AUTH.textPrimary,
                lineHeight: '21px',
              }}
            >
              {email}
            </span>
          </div>
        </div>

        {/* Resend */}
        <p
          style={{
            margin: '0 0 20px',
            fontSize: 16,
            fontWeight: 400,
            color: AUTH.textPrimary,
            lineHeight: '20px',
          }}
        >
          Didn&apos;t receive it?{' '}
          <button
            type="button"
            onClick={handleResend}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              fontSize: 16,
              fontWeight: 600,
              color: AUTH.textPrimary,
              fontFamily: '"Geist", sans-serif',
              textDecoration: 'underline',
              textUnderlineOffset: 2,
            }}
          >
            {resent ? 'Sent!' : resending ? 'Sending…' : 'Resend'}
          </button>
        </p>

        {/* Back link */}
        <button
          type="button"
          onClick={() => navigate('/auth/login')}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 400,
            color: AUTH.textSecondary,
            fontFamily: '"Geist", sans-serif',
            lineHeight: '16px',
          }}
        >
          &larr; Back to sign in
        </button>
      </div>
    </AuthLayout>
  );
}
